import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Clock, CheckCircle2 } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";

interface TokenValidatorProps {
  patientInfo: {
    name: string;
    avatar_url?: string;
  };
  linkInfo: {
    expires_at: string;
    submissions_remaining?: number | null;
  };
}

export function TokenValidator({ patientInfo, linkInfo }: TokenValidatorProps) {
  const initials = patientInfo.name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .substring(0, 2)
    .toUpperCase();

  const expiresAt = new Date(linkInfo.expires_at);

  return (
    <Card className="mb-6">
      <CardContent className="pt-6">
        <div className="flex items-center gap-4">
          <Avatar className="h-16 w-16">
            {patientInfo.avatar_url && (
              <AvatarImage src={patientInfo.avatar_url} alt={patientInfo.name} />
            )}
            <AvatarFallback className="bg-primary/10 text-primary text-lg">
              {initials}
            </AvatarFallback>
          </Avatar>

          <div className="flex-1">
            <h2 className="text-xl font-bold mb-2">{patientInfo.name}</h2>
            <div className="flex flex-wrap gap-2">
              <Badge variant="outline" className="flex items-center gap-1">
                <CheckCircle2 className="h-3 w-3" />
                Link Válido
              </Badge>
              <Badge variant="outline" className="flex items-center gap-1">
                <Clock className="h-3 w-3" />
                Expira {formatDistanceToNow(expiresAt, { addSuffix: true, locale: ptBR })}
              </Badge>
              {linkInfo.submissions_remaining && (
                <Badge variant="outline">
                  {linkInfo.submissions_remaining} envio{linkInfo.submissions_remaining !== 1 ? 's' : ''} restante{linkInfo.submissions_remaining !== 1 ? 's' : ''}
                </Badge>
              )}
            </div>
          </div>
        </div>

        <div className="mt-4 p-3 bg-muted rounded-lg">
          <p className="text-sm text-muted-foreground">
            <strong>Instruções:</strong> Escolha o tipo de dado que deseja enviar ao seu profissional de saúde.
            Os dados serão analisados e adicionados ao seu histórico clínico.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
